export enum ImportExportSubject {
  DatapoolRecords = 'datapoolRecords',
  DatasetRecords = 'datasetRecords',
  Inference = 'inference',
}
